import { Koi } from '@ksyos/koi';

const maxCharacterLength = 25;

export const fundingErrorInformationValidationSchema = {
    schema: Koi.object({ fundingErrorInformation: Koi.string().max(maxCharacterLength).allow(null) }),
};
